export var negate = function negate(fn) {
  return function (x) {
    return !fn(x);
  };
};